import React from 'react';
import axios from 'axios';
import { Box, Button, Tooltip } from '@chakra-ui/react';

import { options } from './data';
import { Process } from './process';

export const Checklist = ({
	customer,
	loaded,
	wake,
	setWake,
	service,
	stage,
}) => {
	const { disabled, label, text } = loaded
		? {
				disabled: true,
				label: 'Загруженные документы находятся на проверке',
				text: 'All the loaded documents are being checked',
		  }
		: {
				disabled: false,
				label: 'Все документы загружены',
				text: 'All the documents are loaded',
		  };

	const onClick = () => {
		axios({
			method: 'put',
			url: `/loaded`,
			data: {
				customer,
				loaded: true,
			},
			...options(),
		})
			.then(() => {
				setWake(new Date().getTime());
			})
			.catch(console.log);
	};

	return (
		<Box mt={6}>
			<Tooltip label={label} placement="bottom-start">
				<Button
					disabled={disabled}
					onClick={onClick}
					d="block"
					w="100%"
					bgColor="green.500"
					borderRadius="md"
					color="white"
					fontSize="xl"
					py="2"
					textAlign="center"
					_hover={{
						textDecoration: 'none',
					}}
					sx={{
						'@media print': {
							display: 'none',
						},
					}}
				>
					{text}
				</Button>
			</Tooltip>
			<Process {...{ service, stage, wakeProcess: wake }} />
		</Box>
	);
};
